import { findApplicant, isDOBEligibleForBTM } from '@hc-frontend/business'

function setBTMEligibility(store) {
  const applicant = findApplicant(store.hcStorage.members)

  store.BTMEligibility = isDOBEligibleForBTM(applicant.dob)

  return Promise.resolve(store)
}

export default setBTMEligibility
